module.exports = __webpack_public_path__ + "static/media/card-image-three.e3626308.png";